import styled from 'styled-components';

export const StyledModelFooter = styled.div`
    > *:not(:last-child) {
        margin-right: 8px;
    }
`;
